// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__XGH_T"};